module.exports = __webpack_public_path__ + "img/arrow-right-icon.07ed933e.svg";